import { render, staticRenderFns } from "./feed-back.vue?vue&type=template&id=4b48016e&"
import script from "./feed-back.js?vue&type=script&lang=js&"
export * from "./feed-back.js?vue&type=script&lang=js&"
import style0 from "./feed-back.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports